export default "__VITE_ASSET__DF_vYALw__"